import { defineStore } from 'pinia';
import { ref } from 'vue';
import { $axios } from 'boot/axios';

export const useRenderStore = defineStore('render', () => {
  const posts = ref(null);
  const postsTotal = ref(0);
  const postsPage = ref(1);
  const perPage = 10;
  const post = ref(null);
  const anchors = ref(null);
  const settings = ref(null);
  const showEmailSubscribeDialog = ref(false);
  const emailForSubscribe = ref(null);

  async function getPosts(host) {
    const { data } = (await $axios(`${process.env.API_HOST}/api/public/blog/posts`, {
      params: {
        url: `https://${host}/`,
        page: postsPage.value,
        perPage,
      },
    })).data;
    posts.value = data.elements;
    postsTotal.value = data.total;
  }

  async function getBlogSettings(host) {
    const { data } = (await $axios(`${process.env.API_HOST}/api/public/blog`, {
      params: {
        url: `https://${host}/`,
      },
    })).data;
    settings.value = data;
  }

  async function getPost({ slug, host, headers = {} }) {
    const { data } = (await $axios(`${process.env.API_HOST}/api/public/route`, {
      params: {
        url: `https://${host}/${slug}`,
      },
      headers,
    })).data;
    post.value = data.entry;
  }

  return {
    post,
    anchors,
    posts,
    postsTotal,
    postsPage,
    perPage,
    settings,
    getPosts,
    getBlogSettings,
    getPost,
    showEmailSubscribeDialog,
    emailForSubscribe,
  };
});
